import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import ServicesSection from '../components/home/ServicesSection';
import './Home.css';

const Services = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="about-hero-section">
        <div className="container">
          <motion.div
            className="section-header"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="section-title">Our Services</h1>
            <p className="section-subtitle">
              Comprehensive construction, development, and real estate solutions
            </p>
          </motion.div>
        </div>
      </section>

      {/* Services Section - Detailed */}
      <ServicesSection />

      {/* Call to Action Section */}
      <section className="commitment-section">
        <div className="container">
          <motion.div
            className="section-header"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="section-title">Ready to Get Started?</h2>
            <p className="section-subtitle">
              Let's discuss how we can help with your project
            </p>
          </motion.div>

          <motion.div
            className="commitment-content"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <p className="commitment-text">
              Contact us today to learn more about our services and how we can help bring your vision to life.
            </p>
            <div className="commitment-buttons">
              <Link 
                to="/contact" 
                className="btn-primary-large"
                onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'instant' })}
              >
                Contact Us
              </Link>
              <Link 
                to="/projects" 
                className="btn-secondary"
                onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'instant' })}
              >
                View Projects
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Services;





